// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-7975533a]{width:1.92rem;height:0.52rem;font-size:0.48rem;font-weight:700;color:#fff;line-height:0.52rem}.container[data-v-7975533a]{margin:0 auto}.home_page[data-v-7975533a]{position:relative;display:flex;align-items:center;justify-content:center}.isFixed[data-v-7975533a]{position:static}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
